import { render } from "./LogoNeo.vue?vue&type=template&id=3136685b&scoped=true"
const script = {}

import "./LogoNeo.vue?vue&type=style&index=0&id=3136685b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3136685b"

export default script